
import HeroSection from './home-components/HeroSection';
import VissionMission from './home-components/VisionMIssion';
import Achievements from './home-components/Achievements';
import Leader from './home-components/Leader';
import ImpactNumbers from './home-components/ImpactNumbers';
import UpcomingProjects from './home-components/UpcomingProjects';
import CsrGallery from './home-components/CsrGallery';
import JoinWithUs from './home-components/JoinWithUs';
import RegistrationProcess from './home-components/RegistrationProcess';
import TopPartners from './home-components/TopPartners';

export default function Home() {
  return (
   <>
   <HeroSection></HeroSection>
   <Leader/>
   <VissionMission/>
   <Achievements/>
   <ImpactNumbers/>
   <UpcomingProjects/>
   <CsrGallery/>
   <JoinWithUs/>
   <RegistrationProcess/>
   <TopPartners/>
   {/* <RegistrationForm/> */}
   </>
  );
}